import { render, staticRenderFns } from "./PromoCrudPage.vue?vue&type=template&id=e21f0706&"
import script from "./PromoCrudPage.vue?vue&type=script&lang=js&"
export * from "./PromoCrudPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports